import React, { useState } from 'react';
import { List } from 'lucide-react';
import EstadoCuentaBancoModal from './EstadoCuentaBancoModal.jsx';

/**
 * Botón "Estado de Cuenta" por fila de Bancos (`resources.finanzas-cxc.jsx#bancos
 * .extraRowActions`, consumido por `ResourcePage` genérico) -- mismo patrón que
 * `pages/socios-retiros/EstadoCuentaSocioButton.jsx` (componente propio porque
 * necesita estado local para abrir/cerrar el modal). Ver `EstadoCuentaBancoModal.jsx`
 * para el detalle de la Tarea 4 de la segunda ronda de auditoría CxC 2026-09-28.
 *
 * Gate: V1 (`ListadoBancos.jsx`) solo gatea la pantalla completa con `user.menuBancos`
 * -- no había un flag separado para este botón -- pero el endpoint real que alimenta
 * el modal (`GET /movimientos-bancos/banco/:id`) se protege en el backend con
 * `movimientos-bancos:ver`, así que el botón se oculta si el usuario no tiene también
 * ese permiso (evita un botón que solo produciría un 403).
 */
export default function EstadoCuentaBancoButton({ row, hasPermiso }) {
  const [abierto, setAbierto] = useState(false);

  if (!hasPermiso('movimientos-bancos:ver')) return null;

  return (
    <>
      <button
        title="Estado de Cuenta" aria-label="Estado de Cuenta"
        className="p-1.5 rounded-md text-success-600 hover:bg-success-50"
        onClick={() => setAbierto(true)}
      >
        <List size={15} />
      </button>
      {abierto && <EstadoCuentaBancoModal banco={row} onClose={() => setAbierto(false)} />}
    </>
  );
}
